<template>
<div class="chapter">
<div class="inner_page">
<a id="pvi"></a><a id="pvii"></a>
<blockquote class="sink">
<p class="center "><em>The patient search and vigil long</em><br/>
<em>Of him who treasures up a wrong.</em><br/>
—L<span class="smallcaps">ORD</span> B<span class="smallcaps">YRON</span></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front03.vue?94be2a76